import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { select } from '@angular-redux/store';
import { Language } from '@ridango/core';
import { DOCUMENT } from '@angular/common';
@Component({
    selector: 'gl-select-language-dialog',
    templateUrl: './select-language-dialog.component.html'
})
export class SelectLanguageDialogComponent {
    @select(['application', 'assetsPath']) assetsPath$;
    @select(['core', 'selectedLanguage']) selectedLanguage$;
    @select(['core', 'region', 'languages']) languages$;
    public selectedLanguage: Language;
    constructor(
        public dialogRef: MatDialogRef<SelectLanguageDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data,
        @Inject(DOCUMENT) private document: Document
    ) {}
    public onSubmit(): void {
        this.dialogRef.close(this.selectedLanguage);
    }
    public closeDialog(): void {
        this.dialogRef.close();
    }
    public selectLanguage(language: Language) {
        this.selectedLanguage = language;
        if (language?.code) {
            this.document.documentElement.lang = language.code;
        }
    }
}
